









  import {Component, Vue, Watch} from 'vue-property-decorator';
  @Component
  export default class Footer extends Vue {
  private path = '/index'
  private fullFooter = 2
  private links: object[] = [
    {
      title: '帮助',
      href: process.env.VUE_APP_URL_HELP || '//www.kancloud.cn/longmao/longmao/1150122',
    },
    {
      title: '隐私',
      href: process.env.VUE_APP_URL_PRIVACY || 'http://www.longmaosoft.com/cn/statement.html',
    },
    {
      title: '用户协议',
      href: process.env.VUE_APP_URL_AGREEMENT || 'http://www.longmaosoft.com/cn/agreement.html',
    },
  ];
  private copyright: string = process.env.VUE_APP_COPYRIGHT || `Copyright@北京安捷智合科技有限公司  &nbsp&nbsp 保留所有权 | <span style="padding: 0 15px">京ICP备14049781号</span>`
    private created() {
      this.path = this.$route.path
      if (this.path.startsWith('/task')||this.path.startsWith('/mine')||this.path.startsWith('/train/')) {
        this.fullFooter = 0
      } else if (this.path.startsWith('/trainDetail')){
        this.fullFooter = 1
      } else {
        this.fullFooter =  2
      }
    }

  @Watch('$route')
  private routeChange(to: any, from: any) {
    this.path = to.path
    console.log(this.path)
    if (this.path.startsWith('/task')||this.path.startsWith('/mine')||this.path.startsWith('/train/')) {
      this.fullFooter = 0
    } else if (this.path.startsWith('/trainDetail')){
      this.fullFooter = 1
    } else {
      this.fullFooter =  2
    }
    console.log(11)
    console.log(this.fullFooter)
  }
}
